/* eslint-disable import/no-named-as-default-member */
/* eslint-disable prefer-destructuring */
import { createSelector } from 'reselect';
import CORE from './selectors.core';
import TOKEN_UTIL from '../../../../../../util/token.customerAppSettings/scanline';
import { getCustomer } from '../../../../../../util/user';

const EMPTY_OBJECT = {};

const getSourceSettingsForCustomer = (customerSettingsSource, analysisPageCustomer) => {
	return (customerSettingsSource || {})[analysisPageCustomer]?.SCANLINE || EMPTY_OBJECT;
}




/**
 * ROOT
 */
export const selectAppSettingsOverride = createSelector(
	CORE.selectAnalysisPageCustomer, 
	CORE.selectCustomerSettingsSource,
	(analysisPageCustomer, customerSettingsSource) => {
		if (analysisPageCustomer && getCustomer() === 'Aegion') {
			const _appSettingsOverride = getSourceSettingsForCustomer(customerSettingsSource, analysisPageCustomer);
			return _appSettingsOverride;
		}
		return undefined;
	}
);



/**
 * IN APP REPORTS
 */

export const selectHasActionPlansForAnalysisPage = createSelector(
	CORE.selectAnalysisPageCustomer,
	CORE.selectCustomerSettingsSource,
	CORE.selectHasActionPlans,
	(analysisPageCustomer, customerSettingsSource, defaultHasActionPlans) => {
		if (analysisPageCustomer && getCustomer() === 'Aegion') {
			const _appSettingsOverride = getSourceSettingsForCustomer(customerSettingsSource, analysisPageCustomer);
			return TOKEN_UTIL.hasSettingEnableActionPlan(_appSettingsOverride);
		}

		return defaultHasActionPlans;
	}
);

export const selectHasClosureReportsForAnalysisPage = createSelector(
	CORE.selectAnalysisPageCustomer,
	CORE.selectCustomerSettingsSource,
	CORE.selectHasClosureReports,
	(analysisPageCustomer, customerSettingsSource, defaultHasClosureReports) => {
		if (analysisPageCustomer && getCustomer() === 'Aegion') {
			const _appSettingsOverride = getSourceSettingsForCustomer(customerSettingsSource, analysisPageCustomer);
			return TOKEN_UTIL.hasSettingEnableClosureReport(_appSettingsOverride);
		}

		return defaultHasClosureReports;
	}
);



/**
 * TABS & LISTS PAGE - LINE LISTS
 */

export const selectHasFeatureCreateAsProjectForAnalysisPage = createSelector(
	CORE.selectAnalysisPageCustomer,
	CORE.selectCustomerSettingsSource,
	CORE.selectHasTabMyProjects,
	(analysisPageCustomer, customerSettingsSource, defaultHasTabMyProjects) => {
		if (analysisPageCustomer && getCustomer() === 'Aegion') {
			const _appSettingsOverride = getSourceSettingsForCustomer(customerSettingsSource, analysisPageCustomer)
			return TOKEN_UTIL.hasSettingEnableMyProjects(_appSettingsOverride);
		}

		return defaultHasTabMyProjects;
	}
);



/**
 * MISCELLANEOUS SETTINGS
 */

export const selectHasSharedStateForAnalysisPage = createSelector(
	CORE.selectAnalysisPageCustomer,
	CORE.selectCustomerSettingsSource,
	CORE.selectHasSharedState,
	(analysisPageCustomer, customerSettingsSource, defaultHasSharedState) => {
		if (analysisPageCustomer && getCustomer() === 'Aegion') {
			const _appSettingsOverride = getSourceSettingsForCustomer(customerSettingsSource, analysisPageCustomer);
			return TOKEN_UTIL.hasSettingEnableSharedStateForAnalysisAndReports(_appSettingsOverride);
		}

		return defaultHasSharedState;
	}
);

export const selectHasBehaviorAutoRemoveIliDataForAnalysisPage = createSelector(
	CORE.selectAnalysisPageCustomer,
	CORE.selectCustomerSettingsSource,
	CORE.selectHasBehaviorAutoRemoveIliData,
	(analysisPageCustomer, customerSettingsSource, defaultHasBehaviorAutoRemoveIliData) => {
		if (analysisPageCustomer && getCustomer() === 'Aegion') {
			const _appSettingsOverride = getSourceSettingsForCustomer(customerSettingsSource, analysisPageCustomer);
			return TOKEN_UTIL.hasSettingAutoRemoveIliData(_appSettingsOverride);
		}

		return defaultHasBehaviorAutoRemoveIliData;
	}
);

export const selectHasSettingEnablePsqlIliDataForAnalysisPage = createSelector(
	CORE.selectAnalysisPageCustomer,
	CORE.selectCustomerSettingsSource,
	CORE.selectHasFeatureEnablePsqlIliData,
	(analysisPageCustomer, customerSettingsSource, defaultHasFeatureEnablePsqlIliData) => {
		if (analysisPageCustomer && getCustomer() === 'Aegion') {
			const _appSettingsOverride = getSourceSettingsForCustomer(customerSettingsSource, analysisPageCustomer);
			return TOKEN_UTIL.hasSettingEnablePsqlIliData(_appSettingsOverride);
		}

		return defaultHasFeatureEnablePsqlIliData;
	}
);

export const selectHasSettingEnableTempUploadAutoRemoveForAnalysisPage = createSelector(
	CORE.selectAnalysisPageCustomer,
	CORE.selectCustomerSettingsSource,
	CORE.selectHasFeatureEnableTempUploadAutoRemove,
	(analysisPageCustomer, customerSettingsSource, defaultHasFeatureEnableTempUploadAutoRemove) => {
		if (analysisPageCustomer && getCustomer() === 'Aegion') {
			const _appSettingsOverride = getSourceSettingsForCustomer(customerSettingsSource, analysisPageCustomer);
			return TOKEN_UTIL.hasSettingEnableTempUploadAutoRemove(_appSettingsOverride);
		}

		return defaultHasFeatureEnableTempUploadAutoRemove;
	}
);

export const selectHasSettingEnablePersistLinkedSurveysForAnalysisPage = createSelector(
	CORE.selectAnalysisPageCustomer,
	CORE.selectCustomerSettingsSource,
	CORE.selectHasFeatureEnablePersistLinkedSurveys,
	(analysisPageCustomer, customerSettingsSource, defaultHasFeatureEnablePersistLinkedSurveys) => {
		if (analysisPageCustomer && getCustomer() === 'Aegion') {
			const _appSettingsOverride = getSourceSettingsForCustomer(customerSettingsSource, analysisPageCustomer)
			return TOKEN_UTIL.hasSettingEnablePersistLinkedSurveys(_appSettingsOverride);
		}

		return defaultHasFeatureEnablePersistLinkedSurveys;
	}
);

export const selectHasFeatureClosureCopyActionPlanForAnalysisPage = createSelector(
	CORE.selectAnalysisPageCustomer,
	CORE.selectCustomerSettingsSource,
	CORE.selectHasFeatureClosureCopyActionPlan,
	(analysisPageCustomer, customerSettingsSource, defaultHasFeatureClosureCopyActionPlan) => {
		if (analysisPageCustomer && getCustomer() === 'Aegion') {
			const _appSettingsOverride = getSourceSettingsForCustomer(customerSettingsSource, analysisPageCustomer)
			return TOKEN_UTIL.hasSettingFeatureClosureCopyActionPlan(_appSettingsOverride);
		}

		return defaultHasFeatureClosureCopyActionPlan;
	}
);




/**
 * CUSTOMER CREATED JOBS
 */

export const selectHasSettingEnableCustomerCreatedJobsForAnalysisPage = createSelector(
	CORE.selectAnalysisPageCustomer,
	CORE.selectCustomerSettingsSource,
	CORE.selectHasCustomerCreatedJobs,
	(analysisPageCustomer, customerSettingsSource, defaultHasCustomerCreatedJobs) => {
		if (analysisPageCustomer && getCustomer() === 'Aegion') {
			const _appSettingsOverride = getSourceSettingsForCustomer(customerSettingsSource, analysisPageCustomer);
			return TOKEN_UTIL.hasSettingEnableCustomerCreatedJobs(_appSettingsOverride);
		}

		return defaultHasCustomerCreatedJobs;
	}
);

export const selectHasSettingHasDefaultUploadsToSearchableForAnalysisPage = createSelector(
	CORE.selectAnalysisPageCustomer,
	CORE.selectCustomerSettingsSource,
	CORE.selectHasDefaultUploadsToSearchable,
	(analysisPageCustomer, customerSettingsSource, defaultHasDefaultUploadsToSearchable) => {
		if (analysisPageCustomer && getCustomer() === 'Aegion') {
			const _appSettingsOverride = getSourceSettingsForCustomer(customerSettingsSource, analysisPageCustomer);
			return TOKEN_UTIL.hasSettingDefaultUploadsToSearchable(_appSettingsOverride);
		}

		return defaultHasDefaultUploadsToSearchable;
	}
);




/**
 * UPLOAD SETTINGS - derived - simplifying selectors names
 */

export const selectBlnHasSharedState = createSelector(
	CORE.selectAnalysisPageCustomer,
	CORE.selectCustomerSettingsSource,
	CORE.selectBlnHasSharedState,
	(analysisPageCustomer, customerSettingsSource, defaultSettingValue) => {
		if (analysisPageCustomer && getCustomer() === 'Aegion') {
			const _appSettingsOverride = getSourceSettingsForCustomer(customerSettingsSource, analysisPageCustomer);
			return !!TOKEN_UTIL.blnHasSharedState(_appSettingsOverride);
		}

		return defaultSettingValue;
	}
);

export const selectBlnAutoRemoveILIUploads = createSelector(
	CORE.selectAnalysisPageCustomer,
	CORE.selectCustomerSettingsSource,
	CORE.selectBlnAutoRemoveILIUploads,
	(analysisPageCustomer, customerSettingsSource, defaultSettingValue) => {
		if (analysisPageCustomer && getCustomer() === 'Aegion') {
			const _appSettingsOverride = getSourceSettingsForCustomer(customerSettingsSource, analysisPageCustomer);
			return !!TOKEN_UTIL.blnAutoRemoveILIUploads(_appSettingsOverride);
		}

		return defaultSettingValue;
	}
);

export const selectBlnAllowTemporaryUploads = createSelector(
	CORE.selectAnalysisPageCustomer,
	CORE.selectCustomerSettingsSource,
	CORE.selectBlnAllowTemporaryUploads,
	(analysisPageCustomer, customerSettingsSource, defaultSettingValue) => {
		if (analysisPageCustomer && getCustomer() === 'Aegion') {
			const _appSettingsOverride = getSourceSettingsForCustomer(customerSettingsSource, analysisPageCustomer);
			return !!TOKEN_UTIL.blnAllowTemporaryUploads(_appSettingsOverride);
		}

		return defaultSettingValue;
	}
);

export const selectBlnAllowSearchableUploads = createSelector(
	CORE.selectAnalysisPageCustomer,
	CORE.selectCustomerSettingsSource,
	CORE.selectBlnAllowSearchableUploads,
	(analysisPageCustomer, customerSettingsSource, defaultSettingValue) => {
		if (analysisPageCustomer && getCustomer() === 'Aegion') {
			const _appSettingsOverride = getSourceSettingsForCustomer(customerSettingsSource, analysisPageCustomer);
			return !!TOKEN_UTIL.blnAllowSearchableUploads(_appSettingsOverride);
		}

		return defaultSettingValue;
	}
);

export const selectBlnDefaultUploadsToSearchable = createSelector(
	CORE.selectAnalysisPageCustomer,
	CORE.selectCustomerSettingsSource,
	CORE.selectBlnDefaultUploadsToSearchable,
	(analysisPageCustomer, customerSettingsSource, defaultSettingValue) => {
		if (analysisPageCustomer && getCustomer() === 'Aegion') {
			const _appSettingsOverride = getSourceSettingsForCustomer(customerSettingsSource, analysisPageCustomer);
			return !!TOKEN_UTIL.blnDefaultUploadsToSearchable(_appSettingsOverride);
		}

		return defaultSettingValue;
	}
);


export default {

	// ROOT
	selectAppSettingsOverride,

	// IN APP REPORTS
	selectHasActionPlansForAnalysisPage,
	selectHasClosureReportsForAnalysisPage,

	// TABS & LISTS PAGE - LINE LISTS
	selectHasFeatureCreateAsProjectForAnalysisPage,

	// MISCELLANEOUS SETTINGS	
	selectHasSharedStateForAnalysisPage,
	selectHasBehaviorAutoRemoveIliDataForAnalysisPage,
	selectHasSettingEnablePsqlIliDataForAnalysisPage,
	selectHasSettingEnableTempUploadAutoRemoveForAnalysisPage,
	selectHasSettingEnablePersistLinkedSurveysForAnalysisPage,
	selectHasFeatureClosureCopyActionPlanForAnalysisPage,

	// CUSTOMER CREATED JOBS
	selectHasSettingEnableCustomerCreatedJobsForAnalysisPage,
	selectHasSettingHasDefaultUploadsToSearchableForAnalysisPage,

	// UPLOAD SETTINGS - derived - simplifying selectors names
	selectBlnHasSharedState,
	selectBlnAutoRemoveILIUploads,
	selectBlnAllowTemporaryUploads,
	selectBlnAllowSearchableUploads,
	selectBlnDefaultUploadsToSearchable,
}
